//CART
export const cartSubtotal = (state) => state.cart.subtotal;
export const regionZone = (state) => state.cart.regionZone;
export const totalWeight = (state) => state.cart.weight;